import { useRoundStore } from '../store/RoundStore'

const ScoreButton = ({ round, holeNum, updateScore, scoreChange, label, isDisabled }) => {
  const setTriggerSave = useRoundStore((state) => state.setTriggerSave)

  return (
    <button
      type="button"
      className="darkButton scoreButton"
      style={{ width: '55px', height: '55px', fontSize: '2em' }}
      disabled={isDisabled}
      onClick={() => {
        setTriggerSave(true)
        const currentScore = parseInt(round.holeScores[holeNum - 1]?.holeScore) || 0
        scoreChange = parseInt(scoreChange)
        updateScore(round.roundId, currentScore + scoreChange)
      }}
    >
      {label}
    </button>
  )
}

export default ScoreButton
